// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { type State } from 'store';
import SearchResults from 'components/search/SearchResults';
import type { PostItem } from 'store/modules/listing';
import { SearchActions } from 'store/actionCreators';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

type Props = {
  result: ?{
    count: number,
    data: PostItem[],
  },
  currentKeyword: string,
  currentPage: number,
  currentMenu: string,
  menu: string,
  pending: boolean,
};

class SearchResultsContainer extends Component<Props> {
  onSearchNext = () => {
    const { currentKeyword, currentPage, currentMenu, pending } = this.props;
    if (pending || !currentKeyword) return;
    SearchActions.nextPublicSearch({
      q: currentKeyword,
      page: currentPage + 1,
      menu: currentMenu,
    });
  };

  componentDidUpdate(prevProps) {
    const { currentKeyword, currentPage, menu } = this.props;
    const { q: q1 } = queryString.parse(this.props.location.search);
    const { q: q2 } = queryString.parse(prevProps.location.search);
    if (currentKeyword && q1 !== q2 || prevProps.menu !== menu) {
      SearchActions.publicSearch({
        q: q1,
        page: currentPage,
        menu,
      });
    }
  }

  componentWillUnmount() {
    SearchActions.initialize();
  }

  render() {
    return (
      <SearchResults
        result={this.props.result}
        onSearchNext={this.onSearchNext}
        menu={this.props.menu}
        currentKeyword={this.props.currentKeyword}
      />
    );
  }
}

export default connect(
  (state: State) => ({
    result: state.search.result,
    currentKeyword: state.search.currentKeyword,
    currentPage: state.search.currentPage,
    currentMenu: state.search.currentMenu,
    pending:
      state.pender.pending['search/NEXT_PUBLIC_SEARCH'] ||
      state.pender.pending['search/PUBLIC_SEARCH'],
  }),
  () => ({}),
)(withRouter(SearchResultsContainer));



// WEBPACK FOOTER //
// ./src/containers/search/SearchResultsContainer.js